import React, { useState, useEffect, Fragment } from 'react';

import { useSelector, useDispatch } from 'react-redux';

//header
import StepperHeader from './stepperHeader/StepperHeader';

//body
import { bodyConfig as bodyConfigStatic } from './configs/bodyConfigs/config';

//footer
import StepperFooter from './stepperFooter/StepperFooter';

import { withRouter } from 'react-router-dom';

//styles
import './styles/stepper.scss';

import Page from '../page/index';

import {
  Dialog,
  Loader,
  SearchInput,
  RadioGroup,
  Link,
  Card,
  CardBody,
  CardWrapper
} from 'cdk-radial';

import SolutionInfoCard from '../solutionInfo/SolutionInfoCard';

import PaymentCheckout from '../paymentCheckout';

import { Loading } from '../loader/Loading';

import SubscriptionSuccessful from '../subscription-successful/SubscriptionSuccessful';

import AuthComponent from '../common/AuthComponent';

import { setScreen } from '../../redux/connectedComponent/uiFactory/uiFactory.slice';
import { screens } from '../config/uiFactory.config';
import { constants as bodyConfigConstants } from '../../utils/hideStep';

import { clearSelectLocations } from '../../redux/connectedComponent/selectedLocations/selectedLocations.slice';
import SelectLocations from './stepperBody/stepperBodyComponents/SelectLocations';
import AgreeToTerms from './stepperBody/stepperBodyComponents/AgreeToTerms';
import EditApiFields from './stepperBody/stepperBodyComponents/EditApiFields';
import SelectPrivacyProtection from './stepperBody/stepperBodyComponents/SelectPrivacyProtection';

import SelectApiSubscriptionSettings from './stepperBody/stepperBodyComponents/SelectApiSubscriptionSettings';

import DMSSelection from './stepperBody/stepperBodyComponents/DMSSelection';
import ReviewSubscription from './stepperBody/stepperBodyComponents/ReviewSubscription';
import CompleteConfiguration from './stepperBody/stepperBodyComponents/CompleteConfiguration';

import { CdkLogo_wht } from '../CdkLogo/CdkLogo';

import BodyContainer from './stepperBody/bodyContainer/BodyContainer';

import { environmentURLs } from '../common/CaptureEnvironment';
import ConfigurationDialog from './stepperBody/stepperBodyComponents/configurationToast/ConfigurationDialog';

import { sendAmplitudeData } from '../../utils/amplitude';
import { AMPLITUDE_EVENTS,AMPLITUDE_PROPERTIES } from '../../constants/amplitudeConstants';
import { trackPageView, PAGE_SECTIONS, PAGE_SUBSECTIONS } from '../../utils/gtm';

import { BUTTON_VARIANTS, Toast, TOAST_POSITIONS, TOAST_VARIANTS, TOAST_VISIBILITY_DURATIONS } from 'cdk-radial';
const ERROR_FETCHING_API_PROVIDER_MESSAGE = 'Something went wrong. Please refresh or try again later.';
const SEARCH_INPUT_SIZE = 'standard';

const SEARCH_INPUT_STYLE = {
  width: 'calc(min(70vw, 794px))',
  height: '48px',
  margin: 'auto'
};

const COMPLETE_CONFIGURATION = 'Complete Configuration';

const STEPPER_SCREENS = {
  [bodyConfigConstants.SELECT_LOCATION]: SelectLocations,
  [bodyConfigConstants.AGREE_TO_TERMS]: AgreeToTerms,
  [bodyConfigConstants.API_SUBSCRIPTION_SETTINGS]: SelectApiSubscriptionSettings,
  [bodyConfigConstants.EDIT_API_FIELDS]: EditApiFields,
  [bodyConfigConstants.PRIVACY_PROTECTION]: SelectPrivacyProtection,
  [bodyConfigConstants.DMS_SELECTION]: DMSSelection,
  [bodyConfigConstants.REVIEW_SUBSCRIPTION]: ReviewSubscription,
  [bodyConfigConstants.COMPLETE_CONFIGURATION]: CompleteConfiguration
};

function Stepper(props) {
  const dispatch = useDispatch();

  let { bodyConfig = {}, solutionData = {overview: {}}, defaultStep, navigatedFromSubscriptionManagement, source } = props;
  let {
    id,
    overview: {
        name,
        publisherName,
        solutionLogo
    }
  } = solutionData;

  const [bodyConfigObj, setBodyConfigObj] = useState(bodyConfigStatic);
  const [stepperHeaderConfig,setStepperHeaderConfig] = useState([]);

  const state = useSelector(state => state.loginDetailsSlice);
  const {solutionInfo,isUserAuthorizedToAccessPrivateApps,privateSolution,errorInGettingOrgName, isSolutionInfoSuccess, constants, apiAndProviderRequiredForTheApp,errorFetchingApiProviders,errorFetchingAsyncApis,errorFetchingApiProviderSelectedByAppPublisher,isSolutionInfoPending, getSignedS3UrlError} = useSelector(state => state.solutionInfoSlice);
  const { isCheckLocationAlreadySubscribedToAppPending,numberOfRequests, isCheckLocationAlreadySubscribedToAppFromBackendPending} = useSelector(state => state.selectLocationsSlice)
  const {redirectURL, entityID, urlParams} = useSelector(state => state.provisionSettings);
  const {locationsProcessingDone} = state;
  const paymentCheckoutState= useSelector(state => state.paymentCheckoutSlice);
  const [isCheckoutOptionOpen, setIsCheckoutOptionOpen] =useState(false);
  const allLocations = state && state.allLocations;
  const allLocationsWithoutmergingcmfs = state && state.allLocationsWithoutMergingCmfs;
  const [currentStep, setCurrentStep] = useState(1);
  const [disableNextButton, setDisableNextButton] = useState(true);
  const [disablePreviousButton, setDisablePreviousButton] = useState(true);
  const [lastStep, setLastStep] = useState(false);
  const [configureStep,setConfigureStep]= useState(false);
  const [numberOfSteps, setNumberOfSteps] = useState(Object.keys(bodyConfigStatic).length);
  const [currentBody, setCurrentBody] = useState(bodyConfigStatic[1]);
  const [subscriptonSuccessScreen, setsubscriptonSuccessScreen] = useState(
    false
  );
  const [restrictedAccess, setRestrictedAccess] = useState(false);
  const [inValidURL, setInValidURL] = useState(false);

  const [dealerPaymentDialog,setDealerPaymentDialog]= useState('');
  const [dealerPaymentCheckedOption, setDealerPaymentCheckedOption] = useState();
  const [dealerPaymentDisabled,setDealerPaymentDisabled] = useState(true);
  const [openConfigureDialog, setOpenConfigureDialog] = useState(false);
  const [showToast,setShowToast]=useState(false)

  let isPending = isSolutionInfoPending || isCheckLocationAlreadySubscribedToAppPending || numberOfRequests || isCheckLocationAlreadySubscribedToAppFromBackendPending;
  const { selectedLocationsWithCMFNumber } = useSelector(state => state.selectLocationsSlice);

  const { dmsApiDetails , privacyProtectionSupported} = useSelector(state => state.selectDMSSlice)

  const OFFLINE_ONLINNE = 'Offline,Online';

  useEffect(()=>{
    const hasErrors = getSignedS3UrlError || errorFetchingApiProviders || errorFetchingAsyncApis || errorFetchingApiProviderSelectedByAppPublisher;
    if (hasErrors && !isPending) {
      setDisableNextButton(true)
      setShowToast(true);
    }
  },[getSignedS3UrlError, errorFetchingApiProviders,disableNextButton,errorFetchingAsyncApis,errorFetchingApiProviderSelectedByAppPublisher,isPending])

  useEffect(()=>{
    const headerNames = {
      [bodyConfigConstants.SELECT_LOCATION]: constants.STEPPER_SELECT_LOCATIONS,
      [bodyConfigConstants.API_SUBSCRIPTION_SETTINGS]: constants.STEPPER_MANAGE_API_SUBSCRIPTION_SETTINGS,
      [bodyConfigConstants.AGREE_TO_TERMS]: constants.STEPPER_AGREE_TO_TERMS,
      [bodyConfigConstants.EDIT_API_FIELDS]: constants.STEPPER_EDIT_API_FIELDS,
      [bodyConfigConstants.PRIVACY_PROTECTION]: constants.STEPPER_PRIVACY_PROTECTION,
      [bodyConfigConstants.DMS_SELECTION]: constants.STEPPER_VERIFY_DMS,
      [bodyConfigConstants.REVIEW_SUBSCRIPTION]: constants.STEPPER_REVIEW,
      [bodyConfigConstants.COMPLETE_CONFIGURATION]: COMPLETE_CONFIGURATION
    };

    const entries = Object.entries(bodyConfig).map(([k, v]) => [Number(k), v]);
    if (entries.length >= 3) {
      setStepperHeaderConfig(
        entries.map(([stepNo, screen]) => ({
          [stepNo]: headerNames[screen]
        }))
      );
      setBodyConfigObj(
        entries.reduce((obj, [stepNo, screen]) => {
          const Component = STEPPER_SCREENS[screen];
          return {
            ...obj,
            [stepNo]: <Component />
          };
        }, {})
      );
      setNumberOfSteps(entries.length);
    }
  }, [bodyConfig, constants]);

  const handlePaymentOptionSelect = event => {
    setDealerPaymentDisabled(false);
    setDealerPaymentCheckedOption(event.target.value);
  };

  const handleClose = function(){
    setDealerPaymentDialog(false)
  }
  const handlePaymentModeAccept = function(){
    if(solutionInfo && solutionInfo.payment_info  && solutionInfo.payment_info.paymentMode === OFFLINE_ONLINNE  && dealerPaymentCheckedOption === 'Online'){
      setIsCheckoutOptionOpen(true);
    }
    else{
      setsubscriptonSuccessScreen(true);
    }
    setDealerPaymentDialog(false);
  }

  useEffect(() => {
    const stepScreen = bodyConfig[currentStep] || Object.values(bodyConfigStatic)[currentStep - 1];
    const headerObj = stepperHeaderConfig.find(item => item[currentStep]);
    const headerLabel = headerObj ? headerObj[currentStep] : null;

    let subsection = PAGE_SUBSECTIONS.SELECT_LOCATIONS;
    if (headerLabel) {
      subsection = headerLabel;
    } else if (stepScreen) {
      const stepNames = {
        [bodyConfigConstants.SELECT_LOCATION]: PAGE_SUBSECTIONS.SELECT_LOCATIONS,
        [bodyConfigConstants.AGREE_TO_TERMS]: PAGE_SUBSECTIONS.AGREE_TO_TERMS,
        [bodyConfigConstants.API_SUBSCRIPTION_SETTINGS]: PAGE_SUBSECTIONS.API_SUBSCRIPTION_SETTINGS,
        [bodyConfigConstants.EDIT_API_FIELDS]: PAGE_SUBSECTIONS.EDIT_API_FIELDS,
        [bodyConfigConstants.PRIVACY_PROTECTION]: PAGE_SUBSECTIONS.PRIVACY_PROTECTION,
        [bodyConfigConstants.DMS_SELECTION]: PAGE_SUBSECTIONS.VERIFY_DMS_ACCOUNTS,
        [bodyConfigConstants.REVIEW_SUBSCRIPTION]: solutionInfo?.activateOnly !== false ? PAGE_SUBSECTIONS.REVIEW_ACTIVATION : PAGE_SUBSECTIONS.REVIEW_SUBSCRIPTION,
        [bodyConfigConstants.COMPLETE_CONFIGURATION]: PAGE_SUBSECTIONS.COMPLETE_CONFIGURATION
      };
      subsection = stepNames[stepScreen] || PAGE_SUBSECTIONS.SELECT_LOCATIONS;
    }

    trackPageView({
      page_section: PAGE_SECTIONS.APP_MANAGEMENT,
      page_subsection: subsection,
    });
  }, [currentStep, stepperHeaderConfig, bodyConfig, solutionInfo?.activateOnly]);

  useEffect(() => {
    if(navigatedFromSubscriptionManagement) {
      goToStep(defaultStep);
    }
  }, [navigatedFromSubscriptionManagement]);

   useEffect(()=>{
    if(!errorInGettingOrgName && solutionInfo && solutionInfo.organizationName && solutionInfo.organizationName.length>0 && privateSolution && !isUserAuthorizedToAccessPrivateApps){
      setRestrictedAccess(true);
    }
    if(!errorInGettingOrgName && solutionInfo && solutionInfo.organizationName && solutionInfo.organizationName.length>0 && privateSolution && isUserAuthorizedToAccessPrivateApps){
      setRestrictedAccess(false);
    }
    if(!errorInGettingOrgName && solutionInfo &&  solutionInfo.organizationName && solutionInfo.organizationName.length>0 && !privateSolution){
      setRestrictedAccess(false);
    }
     if(errorInGettingOrgName && solutionInfo  && privateSolution){
      setRestrictedAccess(true);
    }
  },[errorInGettingOrgName,solutionInfo.organizationName, restrictedAccess, privateSolution, isUserAuthorizedToAccessPrivateApps])

  useEffect(() => {
    if(isSolutionInfoSuccess && solutionInfo.activateOnly === false  &&  !props.match.params.selectedPlanId ){
      setInValidURL(true);
    }
  },[isSolutionInfoSuccess,solutionInfo.activateOnly]);

  function onCheckOut(){
    setsubscriptonSuccessScreen(true)
    setIsCheckoutOptionOpen(false)
  }

  function prepareAndSendAmplitudeData(eventType, properties) {
    const commonProperties = {
      [AMPLITUDE_PROPERTIES.APP_NAME]: solutionInfo?.overview?.name,
      [AMPLITUDE_PROPERTIES.APP_ID]: solutionInfo?.id,
      [AMPLITUDE_PROPERTIES.LOCATION_COUNT]:
        selectedLocationsWithCMFNumber?.length,
      [AMPLITUDE_PROPERTIES.LOCATIONS]: selectedLocationsWithCMFNumber?.map(
        (loc) => ({
          [AMPLITUDE_PROPERTIES.ORG_ID]: loc?.entityId,
          [AMPLITUDE_PROPERTIES.ORG_NAME]: loc?.location,
          [AMPLITUDE_PROPERTIES.ORG_CMF]: loc?.cmfNumber,
        })
      ),
    };

    sendAmplitudeData(eventType, {
        ...commonProperties,
        ...properties,
      },
    )
  }

  function nextStep(currentStep) {
    if (currentStep === 1) {
      prepareAndSendAmplitudeData(AMPLITUDE_EVENTS.SELECT_DEALERSHIP_LOCATIONS,{})
    }
    if(Object.values(bodyConfig)[currentStep-1] === 'PRIVACY_PROTECTION')
    {
      prepareAndSendAmplitudeData(AMPLITUDE_EVENTS.CONFIGURE_CPP,{
        [AMPLITUDE_PROPERTIES.APIS]: apiAndProviderRequiredForTheApp
          .filter((item) => privacyProtectionSupported.hasOwnProperty(item.id))
          .map((api) => ({
            [AMPLITUDE_PROPERTIES.API_ID]: api?.id,
            [AMPLITUDE_PROPERTIES.API_NAME]: api?.displayName,
          })),
      });
    }
    if(Object.values(bodyConfig)[currentStep-1] === 'DMS_SELECTION')
    {
      prepareAndSendAmplitudeData(AMPLITUDE_EVENTS.CONFIGURE_DMS,{
        [AMPLITUDE_PROPERTIES.APIS]: apiAndProviderRequiredForTheApp
          .filter((item) => dmsApiDetails.hasOwnProperty(item.id))
          .map((api) => ({
            [AMPLITUDE_PROPERTIES.API_ID]: api?.id,
            [AMPLITUDE_PROPERTIES.API_NAME]: api?.displayName,
          })),
      });
    }
    let newStep = currentStep + 1;
    if(Object.values(bodyConfig).includes(COMPLETE_CONFIGURATION)){
      if (newStep === numberOfSteps-1) {
        setLastStep(true);
        setConfigureStep(false);
      }else if (newStep === numberOfSteps) {
        setConfigureStep(true);
        setLastStep(false);
      }
    } else {
      if (newStep === numberOfSteps) {
        setLastStep(true);
      }
    }
    setDisablePreviousButton(false);
    setCurrentStep(newStep);
    updateCurrentBody(newStep);
  }

  function previousStep(currentStep) {
    setLastStep(false);

    if (currentStep > numberOfSteps)
      currentStep = numberOfSteps;
    let newStep = currentStep - 1;

    if (disablePrevious(newStep)) {
      setDisablePreviousButton(true);
    }

    setDisableNextButton(false);

    setCurrentStep(newStep);
    updateCurrentBody(newStep);
  }

  function updateCurrentBody(newStep) {
    if (bodyConfigObj[newStep] !== undefined) setCurrentBody(bodyConfigObj[newStep]);
    // check payment checkout
    else if(solutionInfo.payment_info
      && solutionInfo.payment_info.paymentMode === 'Online'
      && !paymentCheckoutState.checkoutDetails){
      setIsCheckoutOptionOpen(true)
    }
    else if(solutionInfo.payment_info  && solutionInfo.payment_info.paymentMode === OFFLINE_ONLINNE){
      setDealerPaymentDialog(true);
    }
    else if(dealerPaymentCheckedOption==='Online'){
      setIsCheckoutOptionOpen(true)
    }
    else {
      if(Object.values(bodyConfig).includes(COMPLETE_CONFIGURATION)){
        setOpenConfigureDialog(true);
      } else {
        setsubscriptonSuccessScreen(true);
      }
    }
  }

  function disablePrevious(newStep) {
    if (1 === newStep) return true;
    else return false;
  }

  function goToStep(step) {
    setCurrentStep(step);
    updateCurrentBody(step);
    if(Object.values(bodyConfig).includes(COMPLETE_CONFIGURATION)){
      if (step === numberOfSteps-1) {
        setLastStep(true);
        return;
      } else if (step === 1) {
        setDisablePreviousButton(true);
        setDisableNextButton(false);
      } else {
        setDisablePreviousButton(false);
        setDisableNextButton(false);
      }
      setLastStep(false);
    } else {
      if (step === numberOfSteps) {
        setDisablePreviousButton(false);
        setLastStep(true);
        return;
      } else if (step === 1) {
        setDisablePreviousButton(true);
        setDisableNextButton(false);
      } else {
        setDisablePreviousButton(false);
        setDisableNextButton(false);
      }
      setLastStep(false);
    }
  }

  function disableNextFromChildrenComponents(disable) {
    setDisableNextButton(disable);
  }

  if (subscriptonSuccessScreen) {
    return (
      <Page email={'abc'} dealershipName={'abc'}>
        <SubscriptionSuccessful
          navigatedFromSubscriptionManagement={navigatedFromSubscriptionManagement}
          solutionData={solutionData}
        />
      </Page>
    );
  }

  function loadSubscriptionManagement(){
    dispatch(setScreen({screen: screens.SUBSCRIPTION_MANAGEMENT, solutionData}));
  }
  function contactPublisher(){
    window.open(`mailto:${solutionInfo.developerId}`);
  }
  if(restrictedAccess){
    let appName = 'App';
    let publisherOrg = 'Publisher';
    if(!errorInGettingOrgName && solutionInfo.organizationName){
      appName = solutionInfo.overview.name;
      publisherOrg = solutionInfo.organizationName;
    }
    return(
    <Fragment>
     <div className="page-header-container">
        <CdkLogo_wht className="page-header-logo"/>
     </div>
    <div>
       <Dialog
        buttonsProps={[
          {
            id: 'restricted-subscription-management-dialog-action',
            onClick: contactPublisher,
            text: 'Contact',
            variant: 'text'
          }
        ]}
        isOpen={true}
        dataTestId="restricted-subscription-management-dialog"
        hideCloseButton={false}
        id="overlay-id"
        title={"Private App"}
        closeLabel="Close"
        onClose = {loadSubscriptionManagement}
       >
        The {appName} is private. Please contact {publisherOrg} to gain access to the app.
       </Dialog>
     </div>
    </Fragment>
    )
  }

  if(inValidURL ){
    return(
    <Fragment>
     <div className="page-header-container">
        <CdkLogo_wht className="page-header-logo"/>
     </div>
    <div>
       <Dialog
        isOpen={true}
        dataTestId="missing-planId-subscription-management-dialog"
        hideCloseButton={false}
        id="overlay-id"
        title={"Plan Id is missing"}
        closeLabel="Close"
        onClose = {loadSubscriptionManagement}
       >
        Resubscribe to the application,<Link
                isInline
                text="Subscribe"
                onClick={() => {
                  window.open(`${environmentURLs.REACT_APP_MARKETPLACE_URL}solutions/${props.match.params.solutionId}`,"_self");
              }}
              />
       </Dialog>
     </div>
    </Fragment>
    )
  }

  function getSolutionInfoCard() {
    if (navigatedFromSubscriptionManagement) {
      return <SolutionInfoCard
        solutionId={id}
        appName={name}
        publisherName={publisherName}
        solutionLogo={solutionLogo}
        showLearnMore
      />;
    }
    else{
      return <SolutionInfoCard showLearnMore />;
    }
  }

  return (
    <Page>
      {getSolutionInfoCard()}
      {
        Object.keys(bodyConfigObj).length ?
          (<div>
            <div className="stepper-container">
              <div className="stepper-header">
                <StepperHeader
                  numberOfSteps={numberOfSteps}
                  currentStep={currentStep}
                  goToStep={step => goToStep(step)}
                  stepperConfig={stepperHeaderConfig}
                  navigatedFromSubscriptionManagement={navigatedFromSubscriptionManagement}
                  source={source}
                  solutionData={solutionData}
                  isConfigureStep={configureStep}
                />
              </div>
              <div className="stepper-body">
                {allLocations && allLocations.length && isSolutionInfoSuccess && locationsProcessingDone ? React.cloneElement(currentBody, {
                  allLocations:
                    allLocations && allLocations.map(location => location.entityId),
                  allLocationsCMFandEntityId: allLocations,
                  disableNextButton: disableNextFromChildrenComponents,
                  showBadge: true,
                  navigatedFromSubscriptionManagement: navigatedFromSubscriptionManagement,
                  solutionId: solutionData && solutionData.id,
                  allLocationsWithDetails: allLocations,
                  allLocationsWithoutMergingCmfs: allLocationsWithoutmergingcmfs,
                }) :
                (
                  <BodyContainer title={constants.TITLE} description={constants.DESCRIPTION}>
                    <div className="select-locations-body">
                      <SearchInput
                        name="select-locations-search-input"
                        id="select-locations-search-input"
                        isAlwaysExpanded
                        placeholder={constants.SEARCH_DEALERSHIP_LOCATIONS}
                        style={SEARCH_INPUT_STYLE}
                        onChange={()=>{}}
                        size={SEARCH_INPUT_SIZE}
                        value={''}
                        disabled={true}
                        isDisabled={true}
                      />
                      {allLocations.length?
                        <div style={{paddingTop: '25px'}}>
                          <div className="select-locations-loader">
                            <Loader label="Fetching Locations..." />
                          </div>
                        </div>:
                        <Card style={{height:'470px'}}>
                          <CardWrapper draggable={false}>
                              <CardBody>
                                <div className='unauth-user'>{`You are unauthorized to ${constants.SUBSCRIBE}, please see your connectCDK Enterprise Administrator.`}</div>
                              </CardBody>
                          </CardWrapper>
                        </Card>
                      }
                    </div>
                  </BodyContainer>
                )
                }
              </div>
              <div className="stepper-footer">
                <StepperFooter
                  isLastStep={lastStep}
                  isConfigureStep={configureStep}
                  onNext={() => nextStep(currentStep)}
                  onPrevious={() => previousStep(currentStep)}
                  disableNextButton={disableNextButton}
                  disablePreviousButton={disablePreviousButton}
                />
              </div>
            </div>
          </div>)
          : <Loading />
      }
       <Dialog id="dialog-payment" isFullScreen={true} isOpen={isCheckoutOptionOpen}  onClose={()=>setIsCheckoutOptionOpen(false)} title="Checkout">
          <PaymentCheckout onClose={()=>setIsCheckoutOptionOpen(false)}  onCheckOut={onCheckOut}/>
        </Dialog>

       <Dialog id="dialog-payment-options" isOpen={dealerPaymentDialog}
        onClose={()=>setDealerPaymentDialog(false)} title="Choose payment method"
        buttonsProps={[{
        id: 'dialog-payment-action-cancel',
        onClick: handleClose,
        text: 'Cancel',
        variant: 'text'
        },
        {
        id: 'dialog-payment-action-proceed',
        onClick: handlePaymentModeAccept,
        text: 'Proceed',
        variant: 'text',
        isDisabled: dealerPaymentDisabled
        }]}
        >
        <div className="payment-radio">
        <RadioGroup
          dataTestId="radio-group"
          id="radio-group-payment-options"
          label="Select your preferred payment method"
          name="payment-options"
          onChange={handlePaymentOptionSelect}
          options={[
            {
              id: 'radio-offline-method',
              label: 'Offline - Pay later via billing from the app publisher',
              value: 'Offline'
            },
            {
              id: 'radio-online-method',
              label: 'Online - Pay now via Credit Card or Bank Transfer (ACH)',
              value: 'Online'
            }
          ]}
          value={dealerPaymentCheckedOption}
        />
        </div>
        </Dialog>
        {openConfigureDialog ?
          <ConfigurationDialog
            urlParam={urlParams}
            redirectURL={redirectURL}
            entityID={entityID}
            openDialog={openConfigureDialog}
            setOpenDialog={setOpenConfigureDialog}
          />
          : null
        }
       { showToast && 
        <div>
              <Toast 
      content={ERROR_FETCHING_API_PROVIDER_MESSAGE} id="toast-2" position={TOAST_POSITIONS.FIXED} variant={TOAST_VARIANTS.NEGATIVE} />
            </div>
        }
    </Page>
  );
}

export default withRouter(AuthComponent(Stepper));
